import React, { useState } from "react";
import { Form, Input, Button, Layout, Typography, Row, Alert } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { useHistory, Link } from "react-router-dom";

import "../../../styles/PageStyles/Login.less";

const { Content } = Layout;
const { Title } = Typography;

const ValidateEmail = () => {
  const [form] = Form.useForm();
  const history = useHistory();

  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {};

  return (
    <Layout className="login-layout">
      <Content>
        <Form form={form} name="normal_login" className="login-form" onFinish={onFinish}>
          <Row className="mb-1">
            <Alert message="Informational Notes" description="Additional description and information about copywriting." type="success" showIcon />
          </Row>
          <Row justify="center">
            <Title level={2} className="fg-primary">
              Validate Your Email
            </Title>
          </Row>
          <Form.Item
            name="email"
            label="Email"
            labelCol={{ span: 24 }}
            rules={[
              {
                type: "email",
                message: "The input is not valid E-mail!",
              },
              {
                required: true,
                message: "Please input your E-mail!",
              },
            ]}>
            <Input size="large" placeholder="Enter your email" />
          </Form.Item>
          <Form.Item>
            <Button block size="large" type="primary" disabled={loading} htmlType="submit">
              {loading && <LoadingOutlined />} Submit
            </Button>
          </Form.Item>
          <Form.Item>
            <Link to="/login">
              <Button type="text">Go back</Button>
            </Link>
          </Form.Item>
        </Form>
      </Content>
    </Layout>
  );
};

export default ValidateEmail;
